module.exports = __webpack_public_path__ + "img/home_0.44b625af.jpeg";